import k from '../k'
import addRobot from '../parts/addRobot'
import addUI from '../parts/addUI'
import { stats } from '../state/globals'

k.loadSprite('bg-robots', 'sprites/background-robots.png', {
  sliceX: 2,
  anims: {
    emptySlot: 0,
    filled: 1
  }
})

export default () => {
  const test = k.getCamPos()
  const bg = k.add([k.sprite('bg-robots'), k.scale(2), k.pos()])

  const { partDisplay } = addUI(7)
  const robot = addRobot(false, partDisplay)
  robot.scale = k.vec2(1.8)
  robot.pos.x = 160
  robot.pos.y = 96

  const tooltipE = robot.add([k.sprite('e'), k.anchor('bot'), k.pos(0, -12)])
  tooltipE.hidden = true

  k.add([
    k.rect(600, 10),
    k.pos(0, 122),
    k.area(),
    k.body({ isStatic: true }),
    k.opacity(0)
  ])
  k.add([
    k.rect(10, 100),
    k.pos(120, 122),
    k.area(),
    k.body({ isStatic: true }),
    k.opacity(0),
    k.anchor('bot')
  ])
  k.add([
    k.rect(10, 100),
    k.pos(450, 122),
    k.area(),
    k.body({ isStatic: true }),
    k.opacity(0),
    k.anchor('bot')
  ])
  const spot = k.add([
    k.rect(40, 40),
    k.pos(258, 122),
    k.area(),
    k.opacity(0),
    k.anchor('bot')
  ])

  let atSpot = false
  spot.onCollide('robot', () => {
    atSpot = true
    tooltipE.hidden = false
  })
  spot.onCollideEnd('robot', () => {
    atSpot = false
    tooltipE.hidden = true
  })

  k.onKeyPress('e', () => {
    if (atSpot) {
      robot.destroy()
      bg.play('filled')
      stats.finish = true
      k.wait(1, () => {
        k.tween(
          k.vec2(2),
          k.vec2(1),
          2,
          (v) => {
            bg.scale = v
            k.setCamPos(test)
          },
          k.easings.linear
        )
      })
    }
  })
}
